<template>
  <div>
    <b-modal
      ref="import-product-modal"
      hide-footer
      title="Thêm sản phẩm từ Excel (Chia hàng)"
      id="modal-prevent-closing-share"
      size="xl"
    >
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a href="#" @click.prevent="downloadTemplate">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span> <b>Bước 2:</b> Tiến hành Import </span>
          <div style="padding-top: 15px">
            <b-form-file
              placeholder="Hãy chọn một tập tin"
              @change="selectFile"
              v-model="file"
              ref="file-input"
              class="mb-2"
            ></b-form-file>
          </div>
        </b-col>
      </b-row>
      <b-container class="mt-4 pl-0 pr-0" v-show="importItems.length > 0">
        <h5>
          Danh sách sản phẩm từ file excel( Tổng:
          {{ importItems.length }} sản phẩm)
        </h5>
        <b-table
          id="my-table-share"
          class="myTable"
          responsive
          bordered
          hover
          :fields="fieldImport"
          :items="importItems"
          :per-page="10"
          :current-page="currentPage"
        >
          <template v-slot:cell(errorReason)="row">
            <span
              v-if="row.item.errorReason"
              class="po-import-error-cell"
            >
              <i class="fas fa-exclamation-circle mr-1"></i
              >{{ row.item.errorReason }}
            </span>
          </template>
        </b-table>
        <b-pagination
          v-show="importItems.length > 10"
          v-model="currentPage"
          :total-rows="importItems.length"
          :per-page="10"
          aria-controls="my-table-share"
        ></b-pagination>
      </b-container>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="validData"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}

/* Cột "Lỗi" trong bảng preview — nền cảnh báo nhạt, chữ đỏ dễ đọc */
.po-import-error-td {
  background-color: #fff5f5;
  color: #d32f2f;
  font-weight: 600;
  vertical-align: middle;
}
.po-import-error-cell {
  display: inline-flex;
  align-items: center;
  white-space: normal;
}
</style>

<script>
import {
  makeToastSuccess,
  makeToastFaile,
  convertPrice,
} from '../../../utils/common';
import xlsx from 'xlsx';
import ApiService from '@/core/services/api.service';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import fileDownload from '../../../utils/file-download';
import { v4 } from 'uuid';
import { get } from 'lodash';

// Endpoint validate riêng cho PO chia hàng (không gắn 1 kho cố định).
const SHARE_VALIDATE_PATH = 'purchase-order/share/import-products/validate';

export default {
  data() {
    return {
      importItems: [],
      file: null,
      excellist: [],
      currentPage: 1,
      fieldImport: [
        { key: 'productCode', label: 'Mã sản phẩm' },
        { key: 'quantity', label: 'Số lượng', tdClass: 'text-right' },
        {
          key: 'errorReason',
          label: 'Lỗi',
          thClass: 'text-danger',
          tdClass: 'po-import-error-td',
        },
      ],
      listResult: [],
    };
  },
  methods: {
    convertPrice,
    async downloadTemplate() {
      try {
        const response = await PurchaseOrderService.downloadImportTemplate();
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      } catch (err) {
        makeToastFaile(
          get(err, 'response.data.message', 'Không tải được file mẫu'),
        );
      }
    },
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, { type: 'binary' });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          });
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.excellist = excellist;
          this.excellist.map((element) => {
            // File chỉ chứa Mã sản phẩm + Số lượng; giá/tên lấy theo Product ở BE.
            this.importItems.push({
              productCode: element['Mã sản phẩm'] || '',
              quantity: element['Số lượng'] ? element['Số lượng'] : 0,
              errorReason: '', // khởi tạo để reactive khi gán lỗi sau validate
            });
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    showModal: function () {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    hideModal() {
      this.$refs['import-product-modal'].hide();
    },
    validData: async function () {
      this.listResult = [];

      if (!this.importItems.length) {
        return makeToastFaile('Vui lòng chọn file Excel có dữ liệu!');
      }

      // Reset cột lỗi trước mỗi lần validate.
      this.importItems.forEach((it) => {
        it.errorReason = '';
      });

      // PO chia hàng không gắn kho — payload chỉ gồm importProducts.
      const data = { importProducts: this.importItems };

      try {
        const response = await ApiService.post(SHARE_VALIDATE_PATH, data);
        const payload = response.data.data || {};
        const valid = payload.valid || [];
        const errors = payload.errors || [];

        // Không bỏ qua dòng sai: gán lý do vào cột "Lỗi" của đúng dòng (theo
        // rowNumber) ngay trong bảng để user đọc & sửa file, KHÔNG import.
        if (errors.length) {
          errors.forEach((e) => {
            const row = this.importItems[e.rowNumber - 1];
            if (row) row.errorReason = e.reason;
          });
          makeToastFaile(
            `Có ${errors.length} dòng không hợp lệ. Vui lòng sửa file rồi import lại.`,
          );
          return;
        }

        valid.forEach((element) => {
          this.listResult.push({
            id: v4(),
            productName: element.productName,
            productCode: element.productCode,
            barCode: element.barCode,
            productId: element.productId,
            unitPrice: element.unitPrice,
            quantity: element.quantity,
            quantityApprove: element.quantityApprove,
            salePowerWeek: element.salePowerWeek,
            salePowerMonth: element.salePowerMonth,
            prevUnitPrice: element.prevUnitPrice,
            inStockQuantity: element.inStockQuantity,
            discountAmount: element.discountAmount,
            totalAmount: element.totalAmount,
            productType: element.productType,
            salePrice: element.salePrice,
            isNew: true,
          });
        });

        makeToastSuccess(`Đã thêm ${valid.length} sản phẩm`);
        this.hideModal();
        this.$emit('validData', this.listResult);
      } catch (err) {
        makeToastFaile(get(err, 'response.data.message', 'Import thất bại'));
      }
    },
  },
};
</script>
